import { Text, type TextProps } from '@lichtblick/photon/atoms/text/text';
import classNames from 'classnames';

import styles from './price-breakdown-row.module.scss';

type PriceBreakdownRowProps =
  | {
      children?: never;
      className?: string;
      isBold?: boolean;
      isBonus?: boolean;
      textSize?: TextProps['size'];
      label?: string;
      value?: string;
    }
  | {
      children: React.ReactNode;
      className?: string;
      isBold?: boolean;
      isBonus?: boolean;
      textSize?: TextProps['size'];
      label?: never;
      value?: never;
    };

export const PriceBreakdownRow: React.FC<PriceBreakdownRowProps> = ({
  children,
  className,
  isBold = false,
  isBonus = false,
  label,
  value,
  textSize = 'xs',
}) => {
  const rowClassName = classNames(styles.row, className);

  return children ? (
    <li className={rowClassName}>{children}</li>
  ) : (
    <li className={rowClassName}>
      <Text bold={isBold} className={styles.text} size={textSize}>
        {label}
      </Text>
      <Text bold={isBold} className={classNames(styles.text, isBonus && styles.bonus)} size={textSize}>
        {value}
      </Text>
    </li>
  );
};
